import React, { useEffect } from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";
import create from "zustand";

import { apiFetch } from "../../../apiBindings";
import useGasStationStore from "../../pages/GasStations/GasStation/store";
import LinkComponent from "../LinkComponent";
import DocumentsCard from "./DocumentsCard";
import MenuCard from "./MenuCard";

const Container = styled.div`
    margin: 20px 0;
`;

const InnerContainer = styled.div`
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    ${({ theme }) => css`
        ${theme.breakpoints.from.small.css`
          ${theme.paddings.containerOuterInner.left}
          ${theme.paddings.containerOuterInner.right}
      `}
    `}
`;

const Headline = styled.h2`
    ${({ theme }) => theme.paddings.containerOuter.left}
    ${({ theme }) => theme.paddings.containerOuter.right}

    padding-bottom: 15px;
    font-size: 2rem;
    color: ${({ theme }) => theme.colors.red.toString()};
    font-weight: 600;
`;

const Subline = styled.h5`
    ${({ theme }) => theme.paddings.containerOuterInner.left}
    ${({ theme }) => theme.paddings.containerOuterInner.right}

    margin-bottom: 10px;
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.blue.toString()};
`;

const ActionContainer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    align-items: center;
    justify-content: center;
`;

const LinkWrapper = styled.div`
    display: block;
    margin: 20px 0;
`;

const useStore = create((set) => ({
    data: null,
    setData: (data) => set({ data }),
}));

const Menu = ({ gasStationId }) => {
    const { startLoading, stopLoading } = useGasStationStore();
    const { data, setData } = useStore();

    useEffect(() => {
        setData([]);
        if (gasStationId !== undefined) {
            startLoading("menus");
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            apiFetch(`/gas-stations/${gasStationId}/menus`)
                .then((response) => response.json())
                .then((response) => {
                    setData(response);
                    stopLoading("menus");
                });
        }
    }, [gasStationId]);

    const hasMenus = () => {
        return data !== null && data.menus && data.menus.length > 0;
    };

    const hasDocuments = () => {
        return data !== null && data.document;
    };

    const hasAllergenes = () => {
        return data !== null && data.allergenes;
    };

    return (
        <Container>
            {data && hasMenus() && (
                <>
                    <Headline>Menüpläne</Headline>
                    {data.menus.map((menu, index) => {
                        return <MenuCard key={index} data={menu} />;
                    })}
                    <InnerContainer>
                        <ActionContainer>
                            {hasAllergenes() && (
                                <LinkWrapper>
                                    <LinkComponent
                                        link={{
                                            text: "Zusatzstoffe und Allergene",
                                            href: data.allergenes,
                                        }}
                                        underline
                                        anchor
                                    />
                                </LinkWrapper>
                            )}
                        </ActionContainer>
                    </InnerContainer>
                </>
            )}

            {hasDocuments() && (
                <InnerContainer>
                    <ActionContainer>
                        <DocumentsCard document={data.document} />
                    </ActionContainer>
                </InnerContainer>
            )}
        </Container>
    );
};

export default Menu;
